import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AgmCoreModule } from '@agm/core';
import { ChartsModule } from 'ng2-charts';
import { NgxMaskModule } from 'ngx-mask';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { TranslateModule } from '@ngx-translate/core';
import { NgxPermissionsModule } from 'ngx-permissions';
import { BreadcrumbModule } from 'xng-breadcrumb';
import { NgxStripeModule } from '@nomadreservations/ngx-stripe';
import { environment } from 'src/environments/environment';
import { AgmOverlays } from "agm-overlays";
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { AlertRoutingModule } from './alert-routing.module';
import { AlertComponent } from './alert.component';
import { ViewAlertComponent } from './view-alert/view-alert.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { NotifyAlertComponent } from './notify-alert/notify-alert.component';
import { ReassignAlertComponent } from './reassign-alert/reassign-alert.component';
import { MediaComponent } from 'src/app/media/media.component';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { AuthInterceptorProvider } from 'src/app/services/token/token-interceptor.service';

@NgModule({
    declarations: [
        AlertComponent,
        MediaComponent,
        NotifyAlertComponent,
        ReassignAlertComponent,
        ViewAlertComponent
    ],
    imports: [
        AlertRoutingModule,
        BreadcrumbModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatNativeDateModule, 
        ChartsModule,
        NgxPermissionsModule,
        NgxSpinnerModule,
        NgxStripeModule.forRoot(environment.stripe_pk),
        NgxMaskModule,
        AgmCoreModule,
        NgbModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        TranslateModule,
        AgmOverlays,
        AgmCoreModule.forRoot({
            apiKey: environment.firebaseConfig.apiKey
        }),
        SelectDropDownModule,
        NgMultiSelectDropDownModule,
        SharedModule
    ],
    providers: [
        AuthInterceptorProvider,
    ]
})
export class AlertModule {}